import useStyle from '../../hooks/useStyle';
import {environment} from '../../../environments/environment';
import React from 'react';
import {useTranslation} from 'react-i18next';
import useScript from '../../hooks/useScript';
import {ProgressBar} from './style';

let failedAttempts = 0;

interface SOPProps {
  type: string,
  businessId: string;
  customUsername: string | undefined | null;
  onComplete: (success: boolean) => void;
  handleOperationGuid : (operationGuid: string) => void;
  handleCustomUsername : (customUsername: string) => void;
  handleOperationId : (operationId: string) => void;
  style?: React.CSSProperties;
}

interface SOPRenderProps extends SOPProps {
  start: (verId: string, type: string) => void;
}


const alertFunction = (msg: string, closeMethod: (this: GlobalEventHandlers, ev: MouseEvent) => void, e: any) => {
  const divContainer = document.createElement("div");
  divContainer.className = "vu.sop.ui.innerVerticalAlign";

  const divAlertText = document.createElement("p");
  divAlertText.className = "pCustomStyle";

  const divShowErrorPicture = document.createElement("div");
  divShowErrorPicture.setAttribute("id", "divImgShowError");
  const imgShowErrorPicture = document.createElement("img");
  imgShowErrorPicture.setAttribute("id", "imgShowErrorCustomSize");

  switch (e.name) {
    case vu.error.TAKE_DOCUMENT_FRONT_ERROR:
    case vu.error.UPLOAD_DOCUMENT_FRONT_ERROR:
      divAlertText.innerHTML = custom.webflow.msg.addFrontError;
      imgShowErrorPicture.src = "assets/img/front-id-error.svg";
      break;
    case vu.error.TAKE_DOCUMENT_BACK_ERROR:
    case vu.error.UPLOAD_DOCUMENT_BACK_ERROR:
      divAlertText.innerHTML = custom.webflow.msg.addBackError;
      imgShowErrorPicture.src = "assets/img/back-id-error.svg";
      break;
    case vu.error.FACE_AUTH_ERROR:
      divAlertText.innerHTML = custom.webflow.msg.faceError;
      imgShowErrorPicture.src = "assets/img/face-error.svg";
      break;
    case vu.error.CAMERA_ERROR:
      divAlertText.innerHTML = custom.webflow.msg.cameraError;
      imgShowErrorPicture.src = "assets/img/refresh_browser.svg";
      break;
    default:
      divAlertText.innerHTML = `<strong>${custom.webflow.msg.errorLine1}</strong><p>${custom.webflow.msg.errorLine2}</p><p>${custom.webflow.msg.errorLine3}</p>`;
      imgShowErrorPicture.src = "assets/img/refresh_browser.svg";
  }
  if (e.message !== undefined && (e.message.includes('ANTISPOOFING_FAIL') || e.message.includes('No more attempts')))
    failedAttempts++;

  console.log("Failed spoofing attempts: " + failedAttempts);
  const buttonClose = document.createElement("button");
  if (failedAttempts > 3) { //TODO: to env
    divAlertText.innerHTML = `<strong>${custom.webflow.msg.errorLine1}</strong><p>${custom.webflow.msg.errorAttempt1}</p><p>${custom.webflow.msg.errorAttempt2}</p>`;
    imgShowErrorPicture.src = "assets/img/emoji-error.svg";

  } else {

    buttonClose.className = "button";
    buttonClose.id = "vu.sop.ui.alertButton";

    buttonClose.innerHTML = custom.webflow.msg.refresh;
    buttonClose.onclick = closeMethod;
  }

  divShowErrorPicture.appendChild(imgShowErrorPicture);

  divContainer.appendChild(divAlertText);
  divContainer.appendChild(divShowErrorPicture);
  if (failedAttempts <= 3) {
    divContainer.appendChild(buttonClose);
  }

  return divContainer;
}

export const SOP = (props: SOPProps) => {
  useStyle('/assets/onboarding/css/vu.sop.ui.css');
  useStyle('/assets/onboarding/css/webflow.custom.css');

  const onFail = async () => {
    props.onComplete(false);
  }

  const onStart = async (verId: string, type: string) => {
    try {
      if (type === 'business') {
        const data = await vu.sop.start();
        console.log(data);
        if (data?.code === 903) {
          props.handleOperationId(vu.sop.operationIdValue);
          props.handleOperationGuid(vu.sop.operationGuidValue);
          props.handleCustomUsername(vu.sop.userNameValue);
          props.onComplete(true);
        } else {
          onFail();
        }
      }

    } catch (e) {
      console.log(e);
      onFail();
    }
  };

  return <SOPRender {...props} start={onStart}/>;
}

export const SOPRender = ({type, businessId, customUsername, style, start}: SOPRenderProps) => {
  const {t} = useTranslation();
  let loadAttempts = 0;

  const loadFiles = async () => {
    try {
      await vu.sop.load('/assets/onboarding');
      vu.sop.api.host = `${environment.apiHost}/api/vu-onboarding-rest`;
      vu.sop.api.headers = type === 'verification' ? {businessId: businessId} : {business: businessId};
      vu.sop.userNameValue = customUsername;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      vu.sop.audio.enabled = false
      vu.sop.ui.alertDraw = function (msg, closeMethod, e) {
        return alertFunction(msg, closeMethod, e);
      }
      start(businessId, type);
    } catch (error) {
      throw error(error.message());
    }
  }

  useScript('/assets/onboarding/js/vu.sop.js', async () => {
    try {
      await loadFiles();
    } catch (error) {
      loadAttempts++;

      if (loadAttempts < 11) {
        await loadFiles();
      } else {
        alert(error);
      }
    }
  });

  return (
    <div id="vu.sop" style={{...style}}>
      <div id="vu.sop.ui">
        <div
          id="vu.sop.ui.whiteLoading"
          className="vu.sop.ui.fullSizeDiv"
          style={{display: 'block'}}
        >
          <div className="vu.sop.ui.innerVerticalAlign">
            <ProgressBar/>
            {/*<img*/}
            {/*  alt=""*/}
            {/*  className="vu.sop.ui.loadingImg"*/}
            {/*  src="data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJjb2ciIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1jb2cgZmEtdy0xNiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik00ODcuNCAzMTUuN2wtNDIuNi0yNC42YzQuMy0yMy4yIDQuMy00NyAwLTcwLjJsNDIuNi0yNC42YzQuOS0yLjggNy4xLTguNiA1LjUtMTQtMTEuMS0zNS42LTMwLTY3LjgtNTQuNy05NC42LTMuOC00LjEtMTAtNS4xLTE0LjgtMi4zTDM4MC44IDExMGMtMTcuOS0xNS40LTM4LjUtMjcuMy02MC44LTM1LjFWMjUuOGMwLTUuNi0zLjktMTAuNS05LjQtMTEuNy0zNi43LTguMi03NC4zLTcuOC0xMDkuMiAwLTUuNSAxLjItOS40IDYuMS05LjQgMTEuN1Y3NWMtMjIuMiA3LjktNDIuOCAxOS44LTYwLjggMzUuMUw4OC43IDg1LjVjLTQuOS0yLjgtMTEtMS45LTE0LjggMi4zLTI0LjcgMjYuNy00My42IDU4LjktNTQuNyA5NC42LTEuNyA1LjQuNiAxMS4yIDUuNSAxNEw2Ny4zIDIyMWMtNC4zIDIzLjItNC4zIDQ3IDAgNzAuMmwtNDIuNiAyNC42Yy00LjkgMi44LTcuMSA4LjYtNS41IDE0IDExLjEgMzUuNiAzMCA2Ny44IDU0LjcgOTQuNiAzLjggNC4xIDEwIDUuMSAxNC44IDIuM2w0Mi42LTI0LjZjMTcuOSAxNS40IDM4LjUgMjcuMyA2MC44IDM1LjF2NDkuMmMwIDUuNiAzLjkgMTAuNSA5LjQgMTEuNyAzNi43IDguMiA3NC4zIDcuOCAxMDkuMiAwIDUuNS0xLjIgOS40LTYuMSA5LjQtMTEuN3YtNDkuMmMyMi4yLTcuOSA0Mi44LTE5LjggNjAuOC0zNS4xbDQyLjYgMjQuNmM0LjkgMi44IDExIDEuOSAxNC44LTIuMyAyNC43LTI2LjcgNDMuNi01OC45IDU0LjctOTQuNiAxLjUtNS41LS43LTExLjMtNS42LTE0LjF6TTI1NiAzMzZjLTQ0LjEgMC04MC0zNS45LTgwLTgwczM1LjktODAgODAtODAgODAgMzUuOSA4MCA4MC0zNS45IDgwLTgwIDgweiI+PC9wYXRoPjwvc3ZnPg=="*/}
            {/*/>*/}
          </div>
        </div>
      </div>
    </div>
  );
};
